import { Switch } from '@src/design-system/switch';
import { cn } from '@src/design-system/helpers';

export type PreviewMode = 'message' | 'live';

type PreviewModeSwitchProps = {
  mode: PreviewMode;
  onModeChange: (mode: PreviewMode) => void;
  className?: string;
};

export function PreviewModeSwitch({
  mode,
  onModeChange,
  className,
}: PreviewModeSwitchProps) {
  const isLive = mode === 'live';

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center gap-2 pt-2',
        className
      )}
      role='group'
      aria-label='Preview mode'
    >
      <span
        className={cn('text-sm font-medium transition-colors text-gray-900')}
      >
        Message
      </span>

      <Switch
        checked={isLive}
        onCheckedChange={(checked) =>
          onModeChange(checked ? 'live' : 'message')
        }
        aria-label={isLive ? 'Live Preview' : 'Message'}
        className='h-7 w-12 shrink-0 data-[state=checked]:bg-primary-1000 data-[state=unchecked]:bg-primary-1000 [&>span]:size-5 [&>span]:data-[state=checked]:translate-x-5 [&>span]:data-[state=unchecked]:translate-x-0.5'
      />

      <span
        className={cn('text-sm font-medium transition-colors text-gray-900')}
      >
        Live Preview
      </span>
    </div>
  );
}
